import BaseModal from './base/BaseModal';
import React from 'react';
import Dropzone from 'react-dropzone';
import I18N from '../classes/I18N';
import translations from '../lang/components/UploadRecordingModal.lang.json';

const i18n = new I18N(translations);

class UploadRecordingModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedFile: null
        }
    }

    updateSelectedFile = (files) => {
        this.setState({selectedFile: files[0]});
        this.props.onFileSelected(files[0]);
        this.props.onClose();
    }

    handleRejectedFile = (files) => {
        let message = i18n.t(this.props.locale, 'fixErrors');
        let errors = [];

        files.forEach((file) => {
            file.errors.forEach((error) => {
                if (!errors.includes(error.code)) {
                    message += '\n  - ' + i18n.t(this.props.locale, error.code);
                    errors.push(error.code);
                }
            });
        });

        alert(message);
    }


    render() {
        return (
            <BaseModal
                show={this.props.show}
                hasHeader={true}
                hasFooter={false}
                onClose={this.props.onClose}
                modalTitle={i18n.t(this.props.locale, 'addVoiceRecording')}
            >
                <div>
                    <Dropzone
                        onDrop={acceptedFiles => this.updateSelectedFile(acceptedFiles)}
                        onDropRejected={rejectedFiles => this.handleRejectedFile(rejectedFiles)}
                        accept={{'audio/mpeg': ['.mp3']}}
                        maxSize={10000000}
                        maxFiles={1}
                        multiple={false}
                    >
                        {({getRootProps, getInputProps}) => (
                            <section>
                                <div className="dropZone" {...getRootProps()}>
                                    <div style={{margin: 'auto', textAlign: 'center'}}>
                                        <input {...getInputProps()} />
                                        <div><img src="../cloud.svg" alt={i18n.t(this.props.locale, 'uploadIconAlt')} /></div>
                                        <p>{i18n.t(this.props.locale, 'dragFileHere')}</p>
                                        <p>{i18n.t(this.props.locale, 'or')}</p>
                                        <button className="active">{i18n.t(this.props.locale, 'browseFiles')}</button>
                                        <div style={{fontSize: '14px', minHeight: '120px', marginTop: '16px', display: 'flex', flexDirection: 'column', justifyContent: 'space-evenly'}}>
                                            <div>
                                                <div>{i18n.t(this.props.locale, 'supportedFileTypes')}:</div>
                                                <div style={{fontWeight: "lighter"}}>.mp3</div>
                                            </div>
                                            <div>
                                                <div>{i18n.t(this.props.locale, 'maxFileSize')}:</div>
                                                <div style={{fontWeight: "lighter"}}>10MB</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        )}
                    </Dropzone>
                    {/* </div> */}
                </div>
            </BaseModal>
        )
    }
}


export default UploadRecordingModal;
